export default __webpack_public_path__ + "static/media/553.aeb78d36.jpg";